<template>
    <div id="app" style="display: flex;flex-wrap: wrap;justify-content: center;">
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex; align-items: center; float:left; height: 65px;">
                    <div class="header-logo">
                        <img id="header-img" src="../assets/logo.png">
                    </div>
                </div>
                <div style="display:flex; float:left; height: 65px;">
                    <div class="header-important">
                        <!-- <div class="company_name">湖南点八芙科技</div> -->
                        <!-- <div class="header-title company_name">mdm.abm.zu99.cn</div> -->
                    </div>
                </div>
            </div>
            <div id="menu_index">
                <!-- web端菜单导航 -->
                <el-menu v-if="seen" active-text-color="#409eff" :default-active="activeIndex" class="el-menu-demo"
                    menu-trigger="click" text-color="#333" style="height: 65px; border:0;background-color: #eef9ff; "
                    mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1" class="header-title" style="background-color: #eef9ff;">首页</el-menu-item>
                    <el-menu-item index="2" class="header-title" style="background-color: #eef9ff;">MDM云服务</el-menu-item>
                    <el-menu-item index="4" class="header-title" style="background-color: #eef9ff;">程序开发</el-menu-item>
                    <!-- <el-submenu index="2">
                        <template slot="title">产品与解决方案</template>
                        <el-menu-item index="2-1">产品微观</el-menu-item>
                        <el-menu-item index="2-2">生鲜果蔬</el-menu-item>
                        <el-menu-item index="2-3" disabled>服装品牌</el-menu-item>
                        <el-menu-item index="2-4" disabled>微商城小程序</el-menu-item>
                    </el-submenu> -->
                    <!-- <el-menu-item index="3" class="header-title" style="background-color: #eef9ff;">交互式风控</el-menu-item>
                    <el-menu-item index="4" class="header-title" style="background-color: #eef9ff;">程序开发</el-menu-item> -->
                    <!-- <el-menu-item index="8" class="header-title" style="background-color: #eef9ff;">注册</el-menu-item>
                    <el-menu-item index="6" class="header-title" style="background-color: #eef9ff;">登录</el-menu-item>
                    <el-menu-item index="7" class="header-title" style="background-color: #eef9ff;">控制台</el-menu-item> -->
                    <!-- <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item> -->
                    <el-menu-item index="5" class="header-title" style="background-color: #eef9ff;">关于我们</el-menu-item>
                </el-menu>
                <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click"
                    text-color="#333" style="height: 65px; border:0;background-color: #eef9ff;" mode="horizontal"
                    @select="handleSelectMobile">
                    <el-submenu index="1" class="header-title mobile_menu">
                        <template slot="title">{{ currentMenu }}</template>
                        <el-menu-item index="1" class="header-title">首页</el-menu-item>
                        <el-menu-item index="2-2" class="header-title">生鲜果蔬</el-menu-item>
                        <el-menu-item index="2-1" class="header-title">产品微观</el-menu-item>
                        <el-menu-item index="3" class="header-title">产品特点</el-menu-item>
                        <el-menu-item index="4" class="header-title">合作伙伴</el-menu-item>
                        <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div v-if="seen" style="display: flex;align-items: center; height: 100%;">
                <!-- <el-button type="text" style="margin-right: 20px;" class="header-title" @click="login">联系</el-button> -->
                <el-button style="margin-right: 20px; width: 77px;" type="primary" plain size="mini" @click="() => {
                    this.$router.push({ name: 'Contactus' });
                }">联系</el-button>
                <!-- <el-button type="primary" class="header-title" @click="register" round>试用</el-button> -->

                <!-- <el-button style="margin-right: 20px;" type="primary" size="mini" icon="el-icon-monitor" @click="login">
                  试用</el-button> -->
                <el-button style="margin-right: 20px;" type="primary" size="mini" icon="el-icon-monitor" @click="mdmgo">
                    鲸乐租后台</el-button>
                <el-button style="margin-right: 20px;" type="primary" size="mini" icon="el-icon-monitor" @click="mdmgoe">
                    e鲸租</el-button>
                <!-- <el-button style="margin-right: 20px;" type="primary" size="mini" icon="el-icon-monitor" @click="riskgo">
                  风控登录</el-button> -->
            </div>
        </div>



        <div class="container" style="clear: both; ">
            <router-view></router-view>
        </div>

        <!-- <div style="width:1281px;margin: 20px auto; background: #fafafc;"> -->
        <!-- <div style="height:1px;padding:0;background-color:#999;">
            </div> -->
        <!-- </div> -->
        <div style="width:1920px;margin: 20px auto;  margin-top: -18px;background-color: #fafafc;">
            <el-row :gutter="20"
                style="display: flex;align-items: center; margin: 0; justify-content: flex-end;padding-bottom: 15px;">
                <el-col :xs="24" :sm="12" style="width: 45%;">
                    <!-- <span style="font-size: 18px;">卓越管理 现在开启>></span>
                    <br /> -->
                    <!-- <span style="font-size: 18px;">Excellent Management, Start Now</span> -->
                    <p class="footer_font">

                        <el-link :href="sysl" :underline="false">首页</el-link> &nbsp; |&nbsp;
                        <el-link :href="mds" :underline="false">MDM云服务</el-link>&nbsp;|&nbsp;
                        <el-link :href="xcx" :underline="false">程序开发</el-link>&nbsp;|&nbsp;
                        <!-- <el-link :href="fks" :underline="false">交互式风控</el-link>&nbsp;|&nbsp;
                        <el-link :href="xcx" :underline="false">程序开发</el-link>&nbsp;|&nbsp;
                        <el-link :underline="false">代运营</el-link> -->
                    </p>
                    <hr />
                    <div style="line-height: 22px; margin: auto;font-weight: 500;" class="footer_font">
                        版权所有© 襄阳澜鲸文化传媒有限公司 &nbsp; 

                        鄂ICP备2023007563号
                    </div>
                    <div style="line-height: 37px;margin: auto;font-weight: 500;" class="footer_font">
                        电话: <span style="color: #c22c20;">15571111163</span> &nbsp; 
                        邮箱：<span
                            style="color: #c22c20;">3333334444@qq.com</span>&nbsp; 
                        地址：<span
                            style="color: black;">湖北省襄阳市老河口张老路4-1</span>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="10" style="text-align: center;">
                    <!-- <div style="display: flex;justify-content: center;">
                        <div style="margin-right: 28px;margin-left: -92px;">
                            <div><img src="../assets/gy.jpg" style="width: 100px;height: 100px;border: 0" /></div>
                            <div class="footer_font">郭经理</div>
                        </div>
                        <div>
                            <div><img src="../assets/xx.jpg" style="width: 100px;height: 100px;border: 0" /></div>
                            <div class="footer_font">江经理</div>
                        </div>
                    </div>
                    <div style="margin-left: -95px;margin-top: 2px;">
                        长按保存图片 &nbsp&nbsp&nbsp扫一扫咨询
                    </div> -->
                </el-col>
            </el-row>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div>
    </div>
</template>

<script>
export default {
    name: "Layout",
    data () {
        return {
            sysl: window.location.origin + "/#/",
            mds: window.location.origin + "/#/mdm",
            fks: window.location.origin + "/#/risk",
            xcx: window.location.origin + "/#/applet",
            activeIndex: '1',
            company: {
                qrcode: require("../../static/other/公众号二维码.jpg"),
            },
            scroll: '',
            timer: '',
            seen: true,
            currentMenu: '首页'
        };
    },
    methods: {
      riskgo() {
        
        window.open('https://new.admin.mdm.zu5.cc/risk/#/user/login', '_blank')
      },
      mdmgoe() {
        window.open('https://ejingzu.lanjingwenhua.cn/admin/start/#/user/login', '_blank')
      },
      mdmgo(){
        window.open('https://bs.lanjingwenhua.cn/admin/start/#/user/login', '_blank')
      },
        handleSelect (key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: "Index" });
                    break;
                case '2':
                    this.$router.push({ name: "Mdm" });
                    break;
                // case '2-1':
                //     window.location.hash = "#产品微观";
                //     break;
                // case '2-2':
                //     this.$router.push({ name: "Fruit" });
                //     break;
                // case '2-3':
                //     this.$router.push({ name: "Fashion" });
                //     break;
                // case '3':
                //     this.$router.push({ name: "Risk" });
                //     break;
                case '4':
                    this.$router.push({ name: "Applet" });
                    break;
                case '5':
                    this.$router.push({ name: "Aboutus" });
                    break;
            }
        },
        handleSelectMobile (key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: "Index" });
                    this.currentMenu = '首页';
                    break;
                case '2-1':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品微观";
                    this.currentMenu = '首页';
                    break;
                case '2-2':
                    this.$router.push({ name: "Fruit" });
                    this.currentMenu = '生鲜果蔬';
                    break;
                case '2-3':
                    this.$router.push({ name: "Fashion" });
                    break;
                case '3':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品特点";
                    this.currentMenu = '首页';
                    break;
                case '4':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#合作伙伴";
                    this.currentMenu = '首页';
                    break;
                case '5':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#关于我们";
                    this.currentMenu = '首页';
                    break;
            }
        },
        handleScroll () {
            this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 600) {  //判断滚动后高度超过400px,就显示
                this.$refs.btn.style.display = 'block';
            } else {
                this.$refs.btn.style.display = 'none'
            }
        },
        backTop () { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 30)
        },
        login () {

            this.$router.push({ name: "Applica" });
            // window.open('https://admin.fastice-tech.com/login')
        },
        register () {
            // window.open('https://admin.fastice-tech.com/registe')
        },
        menuSeen () {
            // 屏幕尺寸
            // let screenHeight = document.body.clientWidth;
            // if (screenHeight > 415) {
            //     this.seen = true;
            // } else {
            //     this.seen = false;
            // }
        },
        logoClick () {
            this.$router.push({ name: "Index" });
            this.currentMenu = '首页';
        }
    },
    mounted () {
        this.menuSeen()
        window.addEventListener('scroll', this.handleScroll)
    },
}
</script>

<style scoped>
.footer_font>a {
    font-size: 1em;
    line-height: 22px;
    margin: auto;
    font-weight: 500;
    color: #000
}

.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none;
}

.el-menu--horizontal>.el-menu-item {
    border-bottom: none;
}

.logo_img {
    float: left;
    /* width: 35%;  */
    width: 627px;
    cursor: pointer;
}

#back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer
}

.header-title {
    font-size: 1em;
}

.company_name {
    font-weight: normal;
    font-size: 1em;
}

.footer_font {
    font-size: 1em;
}

#menu_index {
    float: left;
    width: 30%;
    height: 100%;
    left: -23px;
}

.header {
    margin: auto;
    width: 1920px;
    height: 65px;
    position: fixed;
    background: #eef9ff;
    z-index: 99999;
}

@media screen and (max-device-width: 415px) {
    .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer
    }

    .footer_font {
        font-size: 0.875em;
    }

    #menu_index {
        float: right;
        width: auto;
        height: 100%
    }

    .mobile_menu {}
}

#header-img {
    /* width: 50px; */
    height: 40px;
    float: left;
    margin: auto;
    margin-left: 328px;
}

.header-logo {
    height: 50px;
    width: 50px;
    align-self: center;
}

.header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
}

.footer {
    display: flex;
    align-items: center;
    margin: 10px auto;
    width: 1281px;
}

a {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}
</style>